import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'

import {
  ModifyContractInput,
  modifyContractInputSchema,
} from '../../../../../common/validations'
import { validateFormValues } from '../../../../utils'
import { DATE_FORMATS } from '../../../../utils/dateUtils'
import {
  getAllowedMonthEndDates,
  isAllowedMonthEndDateWithinRange,
} from '../../../../utils/terminationDateUtils'

import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

export const useMonthEndMoveOutDate = (
  now: DateTime,
  disabledAfter: DateTime
) => {
  const { t } = useTranslation(['common', 'contractModification'])
  const moduleConfig = useModuleConfig()
  const endDateLastDayOfMonth =
    moduleConfig.terminateContract?.endDateLastDayOfMonth ?? true

  const allowedDates = endDateLastDayOfMonth
    ? getAllowedMonthEndDates(now, disabledAfter)
    : undefined
  const firstAllowedDate = allowedDates?.[0]

  const description = firstAllowedDate
    ? t('contractModification:texts.monthEndMoveOutDate', {
        date: DateTime.fromJSDate(firstAllowedDate).toFormat(
          DATE_FORMATS.LOCALE_DATE
        ),
      })
    : undefined

  const validateInEffect = (value: string) =>
    allowedDates === undefined ||
    isAllowedMonthEndDateWithinRange(value, now, disabledAfter, allowedDates)
      ? undefined
      : t('common:datePicker.monthEndOnlyValidation')

  const validate = (form: ModifyContractInput) => {
    const allValidationErrors = validateFormValues(
      form,
      modifyContractInputSchema
    )

    if (!allValidationErrors.inEffect) {
      const inEffectError = validateInEffect(form.inEffect)

      if (inEffectError) {
        allValidationErrors.inEffect = inEffectError
      }
    }

    return allValidationErrors
  }

  return { allowedDates, description, validate }
}
